import { useState, useEffect } from 'react';

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mobileCheck = () => {
      // Check for touch events, a common indicator for mobile/tablet devices
      // navigator.maxTouchPoints is a more modern and reliable API
      const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
      return hasTouch;
    };
    
    setIsMobile(mobileCheck());
  }, []);

  return isMobile;
};
